// Application Configuration Constants
export const CONFIG = {
  // Payment Settings  
MINIMUM_PAYMENT_AMOUNT: 2.00,
DEFAULT_PAYMENT_AMOUNT: 2.00,
DEFAULT_INITIAL_PAYMENT: 2.00,
  
  // Pagination Settings
  SUBMISSIONS_PER_PAGE: 50,
  MAX_SUBMISSIONS_PER_PAGE: 100,
  
  // File Upload Settings
  MAX_FILE_SIZE_MB: 5,
  ALLOWED_FILE_TYPES: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp'],
  MAX_IMAGE_DIMENSION: 800,
  IMAGE_QUALITY: 85,
  
  // Form Validation
  MAX_TITLE_LENGTH: 255,
  DESCRIPTION_TRUNCATE_LENGTH: 150,
  
  // UI Settings
  LEADERBOARD_RANKS: {
    GOLD: 1,
    SILVER: 2,
    BRONZE: 3
  },
  
  // Testing Mode (easily togglable)
  TESTING_MODE: {
    ENABLED: false,
    BYPASS_STRIPE: false,
    CREATE_MOCK_PAYMENTS: false
  },
  
  // API Endpoints
  API_ENDPOINTS: {
    SUBMISSIONS: '/api/submissions',
    CREATE_CHECKOUT: '/api/create-checkout-session',
    UPLOAD_IMAGE: '/api/upload-image',
    STRIPE_WEBHOOK: '/api/stripe-webhook'
  }
};

// Error Messages
export const ERROR_MESSAGES = {
  REQUIRED_TITLE: 'Title is required',
  REQUIRED_DESCRIPTION: 'Description is required',
  INVALID_URL: 'Please enter a valid website URL',
  MINIMUM_PAYMENT: `Minimum payment is $${CONFIG.MINIMUM_PAYMENT_AMOUNT.toFixed(2)}`,
  MINIMUM_PAYMENT_CREATE: `Minimum payment is $${CONFIG.MINIMUM_PAYMENT_AMOUNT.toFixed(2)}. Please enter at least $${CONFIG.MINIMUM_PAYMENT_AMOUNT.toFixed(2)} to create your submission.`,
  FILE_TOO_LARGE: `File size must be less than ${CONFIG.MAX_FILE_SIZE_MB}MB`,
  INVALID_FILE_TYPE: 'Please select a valid image file (PNG, JPG, JPEG, GIF, or WebP)',
  UPLOAD_FAILED: 'Failed to upload image',
  SUBMISSION_FAILED: 'Failed to create submission. Please try again.',
  PAYMENT_FAILED: 'Failed to initiate payment. Please try again.',
  LOAD_FAILED: 'Failed to load submissions. Please try again.'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  IMAGE_UPLOADED: '✓ Image uploaded successfully',
  SUBMISSION_CREATED: '🎉 Submission created successfully!',
  PAYMENT_SUCCESS: '🎉 Payment successful!',
  PAYMENT_REDIRECT: 'Redirecting to secure payment...'
}; 